<app-basic-page [pageTitle]="'Leaderboard'">
  <h3>{{ startTime | toLocaleFormat: 'LLL dd' }} - {{ endTime | toLocaleFormat: 'LLL dd' }}</h3>
</app-basic-page>
